// 不需要传token的接口列表，如果是这些接口就把header里面的token去掉
const notNeedTokenUrl = [
  "navigationActivity/getByActivityIdForH5",
  "integration/buriedCodeManage/process",
  "getShareParams",
  "ArrangementActivity/queryArrangementActivityDetail",
  "lookUpManage/listPermissionTypeAndSys"
];
// 引用工具文件
import utils from "@/utils/index.js";
import { config } from "./config";
// 配置API接口地址
let root = "http://ihlp-dev.honor.cn";
let serviceContext = {
  user: "accountzuul/user/",
  permission: "accountzuul/permission/",
  item: "accountzuul/item/",
  operate: "accountzuul/operate/",
  accountzuul: "accountzuul/",
  assignment: "accountzuul/assignment",
  finance: "accountzuul/finance/",
  purchase: "accountzuul/purchase/",
  merchant: "accountzuul/merchant/",
  inventory: "accountzuul/inventory/",
  excel: "accountzuul/excel/",
  // marketing:"mobileZuul/marketing/h5/",
  marketing: "nonauthzuul/nonauthmkt/h5/",
  trade: "accountzuul/trade/",
  commonexcel: "accountzuul/commonexcel/",
  member: "accountzuul/member/",
  member2: "mobileZuul/member/",
  nonauthmkt: "nonauthzuul/nonauthmkt/",
  accMarketing: "accountzuul/marketing",
  mobileOperate: "mobileZuul/operate/",
  mobileMarketing: "mobileZuul/marketing/",
  mobileMarketingH5: "mobileZuul/marketing/h5/",
  mobileMarketingH5Login: "mobileZuul/h5/",
  mobileWx: "mobileZuul/wx/",
  mobileUser: "mobileZuul/permission/",
  ses: "isrp/ses",
  sms: "isrp/sms",
  mobileWxMix: "mobileZuul/wechat/"
};
// 引用axios
let axios = require("axios");
let iview = {};
let loading = "";
let loadingCount = 0;
let openMask = false;
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null || o[key] === "") {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
      //删除空对象
      if (Object.keys(o[key]).length === 0) {
        delete o[key];
      }
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
//打开loading
function loadingOpen(time) {
  loading = iview.Message.loading({
    content: "Loading...",
    duration: 0
  });
  //开启遮罩
  if (openMask) {
    utils.dom.addServiceLoading();
  }
  //<div class="ivu-modal-mask" style=""></div>
}

//关闭loading
function closeLoading() {
  loading = loading;
  //延迟200毫秒改变loading
  setTimeout(function() {
    loadingCount--;
    if (loadingCount === 0) {
      if (openMask) {
        utils.dom.closeServiceLoading();
        openMask = false;
      }
      if (typeof loading == "function") {
        loading();
      }
    }
  }, 500);
}
// SES、SMS接口路径处理
function SESInterfaceHandler(url, sc) {
  let absoluteUrl = "";
  if (typeof url === "object" && url) {
    if (url.sc === "ses" || url.sc === "sms") {
      absoluteUrl = url.url;
    }
  } else if (sc === "ses" || sc === "sms") {
    absoluteUrl = url;
  }
  return absoluteUrl;
}
/*
  接口处理函数
*/
function apiAxios(method, url, params, success, failure, sc, noLoading) {
  // ses接口处理
  const sesUrl = SESInterfaceHandler(url, sc);

  let tempSc = sc;
  //如果传递过来的是对象，则复制一份。
  if (toType(params) === "object") {
    params = Object.assign({}, params);
  }
  let baseURL = root;
  const userToken = sessionStorage.getItem("userToken");
  const accessToken = sessionStorage.getItem("accessToken");
  //设置headers
  const token = utils.getCookie("Authenticate");
  const headers = {
    system_name: "hd",
    traceId: utils.getuid(),
    "x-from": "h5-hd",
    "x-user-token": userToken || "",
    "x-access-token": accessToken || ""
  };
  // 灰度环境请求头要加gray，别的时候不能加
  const reg = RegExp(/hdbeta/);
  const isGray = reg.test(location.pathname); //灰度环境
  if (isGray) {
    headers["x-env"] = "gray";
  }

  let onUploadProgress = "";
  if (token) headers.Authorization = "Bearer " + token;

  //判断调用api的是否是对象模式
  if (toType(url) === "object") {
    params = url.params;
    //根据条件去掉空参数
    if (params && !url.notFilterNull) {
      params = filterNull(params);
    }
    Object.assign(headers, url.headers);
    openMask = url.openMask;
    success = url.success;
    failure = url.failure;
    noLoading = url.noLoading;
    if (url.onUploadProgress) {
      onUploadProgress = url.onUploadProgress;
    }
    const sc = (url.sc && serviceContext[url.sc]) || "";
    tempSc = sc;
    url = url.url;

    baseURL = sc ? root + "/" + sc : root;
  } else if (sc) {
    //去掉空参数
    if (params) {
      params = filterNull(params);
    }
    sc = serviceContext[sc];
    tempSc = sc;
    baseURL = sc ? root + "/" + sc : root;
  }

  axios.defaults.crossDomain = true;
  axios.defaults.withCredentials = true;
  if (sesUrl && config.env !== "dev") {
    url = sesUrl;
    baseURL = config.baseUrl;
  }
  //拼接请求对象
  const cfgObj = {
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    baseURL: baseURL,
    withCredentials: true,
    async: false,
    headers: headers
  };
  if (onUploadProgress) cfgObj.onUploadProgress = onUploadProgress;
  console.log("请求配置cfgObj：", cfgObj);
  //调用服务
  if (isNotNeedToken(cfgObj)) {
    // 如果是这个接口，就去掉请求头里面的两个token字段
    delete cfgObj.headers["x-user-token"];
    delete cfgObj.headers["x-access-token"];
  }
  axios(cfgObj)
    .then(function(res) {
      console.log("请求url-->", `${baseURL}${url}`, "返回=>", res.data);
      // 判断接口路径里是否存在ses、sms
      if (["ses", "sms"].includes(tempSc)) {
        if (success) {
          success(res.data);
        }
      } else {
        if (res.data.code === 200 || res.status === 200) {
          if (success) {
            success(res.data);
          }
        } else if (res.data.code === 403) {
          window.location.href = res.data.message + "?system_name=hd";
        }
        //登录失效
        else if (res.data.code === 1001) {
          window.location.href = root + "/accountzuul/logout?system_name=hd";
        } else {
          if (failure) {
            failure(res.data);
          } else {
            setTimeout(() => {
              iview.Dialog.alert({
                message: res.data.message || "活动过于火爆，请稍后再试"
              });
            });
          }
        }
      }
    })
    .catch(function(err) {
      let res = err.response;
      console.error("请求url-->", `${baseURL}${url}`, "返回=>", err);
      if (failure) {
        failure(err);
      } else {
        iview.Dialog.alert({
          message: "活动过于火爆，请稍后再试"
        });
        if (err) {
          console.error("api error, HTTP CODE: " + res);
          console.error("api error, HTTP CODE: " + err.message);
          if (baseURL.indexOf("localhost:80") > -1) {
            console.error(err);
          } else {
            console.error("api error, HTTP CODE: " + err.message);
          }
        }
        // console.log('error: ' + JSON.stringify(res.data))
      }
    });
}

// 下载文件
function download(url, sc) {
  if (!url) {
    return;
  }
  sc = serviceContext[sc];
  let baseURL = sc ? root + "/" + sc : root;
  baseURL = baseURL + url;
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = baseURL;
  // link.setAttribute('download', 'excel.xlsx')
  link.setAttribute("target", "_self ");
  link.click();
}
/**
 * 判断当前请求是否需要携带token信息
 * @param {Object} config axios请求配置对象
 * @returns
 */
function isNotNeedToken(config) {
  let includeTag = false;
  notNeedTokenUrl.forEach(item => {
    if (config && config.url && config.url.includes(item)) {
      includeTag = true;
    }
  });
  return includeTag;
}
// 返回在vue模板中的调用接口
export default {
  init: function(view) {
    Object.assign(iview, view);
    root = window.location.origin;
    return new Promise(function(resolve, reject) {
      resolve({
        result: [{ displayname: "***", uuid: "***", userId: "***" }]
      });
    });
  },
  //登录
  login(resolve, reject) {
    let self = this;
    let p = new Promise(function(resolve, reject) {
      apiAxios(
        "POST",
        "/login",
        null,
        r => {
          //登录成功，调用服务取用户
          apiAxios(
            "POST",
            "/userManager/getUserMessageByUUIDLocal",
            {},
            data => {
              resolve(data);
            },
            e => {
              reject({
                result: e,
                errorCode: "A0001",
                errorMessage: "获取用户信息失败!"
              });
            },
            "user"
          );
        },
        null,
        "accountzuul"
      );
    });
    return p;
  },
  //注销
  loginout() {
    window.location.href = root + "/accountzuul/logout?system_name=hd";
  },
  myapiAxios(method, url, params, success, failure, sc, noLoading) {
    apiAxios(method, url, params, success, failure, sc, noLoading);
  },
  getContext: function(name) {
    return this.serviceContext[name];
  },
  get: function(url, params, success, failure, sc, noLoading) {
    return this.myapiAxios("GET", url, params, success, failure, sc, noLoading);
  },
  post: function(url, params, success, failure, sc, noLoading) {
    return this.myapiAxios(
      "POST",
      url,
      params,
      success,
      failure,
      sc,
      noLoading
    );
  },
  put: function(url, params, success, failure, sc, noLoading) {
    return this.myapiAxios("PUT", url, params, success, failure, sc, noLoading);
  },
  delete: function(url, params, success, failure, sc, noLoading) {
    return this.myapiAxios(
      "DELETE",
      url,
      params,
      success,
      failure,
      sc,
      noLoading
    );
  },
  form: function(method, cfg) {
    cfg.notFilterNull = true;
    return this.myapiAxios(method, cfg);
  },
  filterNull: function(data) {
    return filterNull(data);
  },
  download(url, sc) {
    download(url, sc);
  }
};



// WEBPACK FOOTER //
// ./src/api/axios.js